/* eslint semi: 1 */
import { asyncValidationRule } from '@/element-ui/form-utils';
import _ from 'lodash';

export const validateNumber = (errorMessage) => {
  return asyncValidationRule(async (rule, value) => {
    // Validate non numeric characters
    if (_.isString(value) && value.match(/[^\d.]+/)) {
      return new Error(errorMessage);
    }

    const parsedValue = Number.parseFloat(value);
    if (isNaN(parsedValue) || parsedValue <= 0) {
      return new Error(errorMessage);
    }
  });
};
